//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from '../../formMixin';
import { placeholderPositionEnum } from '../../../components/js/enum';
export default {
  name: 'SearchForm',
  mixins: [mixin],
  data: function data() {
    return {
      placeholderPositionEnum: placeholderPositionEnum,
      form: {
        showType: 3,
        searchType: 1,
        searchPadding: {
          pt: 14,
          pb: 14,
          pl: 15,
          pr: 15
        }
      }
    };
  },
  watch: {
    propsData: {
      handler: function handler(propsData) {
        var _this$form;
        this.form = Object.assign(this.form, propsData);
        if (!((_this$form = this.form) !== null && _this$form !== void 0 && _this$form.searchPadding)) {
          this.$set(this.form, 'searchPadding', {
            pt: 14,
            pb: 14,
            pl: 15,
            pr: 15
          });
        }
        ;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    uploadbgImg: function uploadbgImg(prop) {
      var _this = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _this.$set(_this.form, prop, data[0].sattDir);
      });
    }
  }
};